<template>
  <v-row>
    <v-col cols="12" sm="8" offset-sm="2">
      <v-card>
        <v-card-title primary-title>
          <div class="text-h4">
            Beställ buntblock         
          </div>
          <v-spacer />         
        </v-card-title>   
        <v-card-text v-show="!model.ordered">
          <p>Du kan beställa ett nytt buntblock med returetiketter genom att klicka på knappen ”beställ”.</p>
        </v-card-text>
        <v-card-text v-show="model.ordered">
          <p>En ny beställning av buntetikettblock har gjorts med en serie mellan <b>{{ model.fromNumber }} - {{ model.toNumber }} </b></p>
          <p>
            Det nya blocket levereras med ordinarie postgång och bör vara er tillhanda om 3-4 veckor. <br> Om dina returetiketter redan är slut kan du, tills du får det nya buntblocket, skriva ut <router-link :to="{ name: 'nodetiketter'}">
              Nödetiketter
            </router-link>
          </p>
        </v-card-text>
        <v-card-actions>          
          <v-btn v-show="!model.ordered"
                 :loading="loading"
                 :disabled="model.ordered"
                 @click="order()"
          >
            Beställ
          </v-btn>        
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row> 
</template>
<script>
import api from '@/backend/api'
import log from '@/logger'

export default {
  name: 'BundlesOrder',  
  data() {
    return {
      model: {},
      loading: false
    }
  },
  methods: {
    order() {
      
      this.loading = true
     
      api.orderBundle()
        .then(resp => {
          this.model.fromNumber = resp.data.fromNumber
          this.model.toNumber = resp.data.toNumber
          this.model.ordered = true
          
          this.loading = false
          log.debug('OrderBundle:', this.model)
          //log.debug('Success:', paper)         
          
        })
        .catch(error => {
          this.loading = false
          log.debug('Errors:', error)
        })
    },

  }
}
</script>
